import { jsx as r } from "react/jsx-runtime";
const e = () => /* @__PURE__ */ r("rect", { x: "4", y: "4", width: "16", height: "16", stroke: "currentColor", strokeWidth: "2", strokeDasharray: "3 3" });
export {
  e as default
};
